require('angular');

var app = angular.module('MyApp', []);

app.directive('setFocus', ["$timeout",
    function ($timeout) {
        return function (scope, element, attrs) {
            scope.$watch(attrs.setFocus,
                    function (newValue) {
                        $timeout(function () {
                            if (newValue) {
                                element[0].focus();
                            }
                        });
                    }, true);
        };
    }
]);

app.directive("deferredCloak", function () {
    return {
        restrict: 'AC',
        link: function (scope, element, attrs) {
            attrs.$set("deferredCloak", undefined);
            element
                    .removeClass("deferred-cloak")
                    .addClass("deferred-cloak-loaded");
        }
    };
});

app.directive('validateEmail', function () {
    var EMAIL_REGEXP = /^[_a-z0-9+-]+(\.[_a-z0-9+-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/i;

    return {
        require: 'ngModel',
        restrict: '',
        link: function (scope, elm, attrs, ctrl) {
            // only apply the validator if ngModel is present and Angular has added the email validator
            if (ctrl && ctrl.$validators.email) {

                // this will overwrite the default Angular email validator
                ctrl.$validators.email = function (modelValue) {
                    return ctrl.$isEmpty(modelValue) || EMAIL_REGEXP.test(modelValue);
                };
            }
        }
    };
});

app.controller('ContactFormController', ["$scope", "$http", function ($scope, $http) {
        $scope.showRecaptcha = true;
        $scope.formError = false;
        $scope.formSubmited = false;
        $scope.formSubmitting = false;
        $scope.formModel = {};

        $scope.submitForm = function () {
            $scope.formError = false;
            $scope.formSubmited = false;

            if ($scope.form.$valid) {
                $scope.formSubmitting = true;

                $http({
                    url: jsData.ajaxUrl,
                    method: 'POST',
                    data: jQuery.param({
                        action: 'contact_form',
                        nonce: jsData.nonce,
                        data: $scope.formModel
                    }),
                    headers: {'Content-Type': 'application/x-www-form-urlencoded'}
                }).then(function (data) {
                    $scope.formSubmitting = false;

                    if (data.data.success) {
                        $scope.formSubmited = true;
                        $scope.form.$setPristine();
                        $scope.form.$setUntouched();
                        $scope.formModel = {};
                    } else if (!data.data.success) {
                        $scope.formError = true;
                    }

                    $('html, body').animate({
                        scrollTop: ($('#formAlerts').offset().top - $('.fixed-top').outerHeight() - 30)
                    }, 'slow');
                });
            }
        };
    }
]);


// WEBPACK FOOTER //
// ./scripts/angular_app.js